/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
import AnimatedPage from "../animated/AnimatedPage";
import "./style/navbar.css";

function Navbar() {
  const navigate = useNavigate();
  return (
    <AnimatedPage>
      <div className="navbar">
        <a href="#" className="animated-button1" onClick={() => navigate("/")}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          About
        </a>
        <a
          href="#"
          className="animated-button1"
          onClick={() => navigate("/product")}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Product
        </a>
        <a
          href="#"
          className="animated-button1"
          onClick={() => navigate("/contact")}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Contact
        </a>
        <a href="#" className="animated-button1" onClick={() => navigate("/skills")}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          My Cv
        </a>
        <a href="#" className="animated-button1" onClick={() => navigate("/certificate")}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Certificate
        </a>
      </div>
    </AnimatedPage>
  );
}

export default Navbar;
